import '../styles/tailwind.css';
import '../styles/style.css';
import logoPD from '../assets/logoPD.png';
import fplaytLogo from '../assets/fplaytLogo.png';
import registerBg from '../assets/registerBg.png';
import loginBg from '../assets/loginBg.png';
import { useState, useEffect } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router";
import Cookies from 'js-cookie';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';

const API_URL = 'https://panelpolitie.fplayt.ro';

function AuthPage() {
    const navigate = useNavigate();
    const [registerEmail, setREmail] = useState<string>('');
    const [registerPassword, setRPassword] = useState<string>('');
    const [registerPasswordConfirm, setRPasswordC] = useState<string>('');
    const [registerToken, setRToken] = useState<string>('');
    const [loginEmail, setLEmail] = useState<string>('');
    const [loginPassword, setLPassword] = useState<string>('');
    const [isLoginClicked, setIsLoginClicked] = useState<boolean>(true);
    const [showRPassword, setShowRPassword] = useState(false);
    const [showRCPassword, setShowRCPassword] = useState(false);
    const [showLPassword, setShowLPassword] = useState(false);

    useEffect(() => {
        const connected = Cookies.get('accountCreated');
        if (Boolean(connected) === true) {
            navigate('/mainPanel')
        }
    }, []);

    async function registerAccount() {
        if (!registerEmail || !registerPassword || !registerPasswordConfirm || !registerToken) {
            toast.error("Trebuie sa completezi toate campurile!");
        } else if (registerPassword !== registerPasswordConfirm) {
            toast.error("Parola de confirmare trebuie sa fie aceeasi cu cea initiala!");
        } else {
            try {
                const response = await axios.post(`${API_URL}/api/register`, {
                    email: registerEmail,
                    password: registerPassword,
                    rToken: registerToken
                });

                localStorage.setItem("token", response.data.accessToken);
                localStorage.setItem("refreshToken", response.data.refreshToken);
                Cookies.set("email", registerEmail);
                navigate("/createAccount");
            } catch (err) {
                console.log(err);
                toast.error("A aparut o eroare! Contul nu a fost creat.")
            }
        }
    }

    async function loginAccount() {
        if (!loginEmail || !loginPassword) {
            toast.error("Trebuie sa completezi toate campurile!");
        } else {
            try {
                const response = await axios.post(`${API_URL}/api/login`, {
                    email: loginEmail,
                    password: loginPassword,
                });
                if (response && response.data) {
                    localStorage.setItem("token", response.data.accessToken);
                    localStorage.setItem("refreshToken", response.data.refreshToken);
                    Cookies.set('accountCreated', 'true');
                    toast.success("Te-ai conectat cu succes!");
                    Cookies.set("myDiscordID", response.data.userDiscord);
                    Cookies.set("email", loginEmail);
                    navigate("/mainPanel");
                    return;
                }
            } catch (err) {
                console.log(err);
            }
        }
    }

    return (
        <div className="w-full h-full relative flex items-center overflow-hidden">
            <div className="background-container">
                <div
                    className={`background-image ${isLoginClicked ? 'hidden' : 'visible'}`}
                    style={{ backgroundImage: `url(${registerBg})` }}
                ></div>
                <div
                    className={`background-image ${isLoginClicked ? 'visible' : 'hidden'}`}
                    style={{ backgroundImage: `url(${loginBg})` }}
                ></div>
            </div>

            <div className={`authBG ml-[1%] w-[35%] h-[96%] flex flex-col items-center justify-center rounded-[3vw] bg-[radial-gradient(ellipse_at_center,_#FFFFFF_0%,_#CACACA_100%)] shadow-[0_0_13.8px_9px_rgba(0,0,0,0.25)] transition-all duration-500 ${isLoginClicked ? 'translate-x-[180%]' : ''}`}>
                <img className="w-[20%]" src={logoPD} alt="Logo" />
                <span className="textBold text-[#000000] text-[3vw] mt-[5%]">{isLoginClicked ? 'Intră în cont' : 'Creează-ți cont'}</span>

                <div className={`registerForm w-[62%] h-[55%] flex flex-col items-center gap-[2%] mt-[5%] ${isLoginClicked ? 'hidden' : 'flex'}`}>
                    <input
                        onChange={e => setREmail(e.target.value)}
                        placeholder="Email"
                        type="text"
                        className="textSemiBold text-center outline-none placeholder-[#868686] text-[#868686] text-[1vw] w-full h-[12%] bg-transparent rounded-[2vw] border border-[#323232]"
                    />
                    <div className="relative w-full h-[12%]">
                        <input
                            onChange={e => setRPassword(e.target.value)}
                            placeholder="Parola"
                            type={showRPassword ? "text" : "password"}
                            className="textSemiBold text-center outline-none placeholder-[#868686] text-[#868686] text-[1vw] w-full h-full bg-transparent rounded-[2vw] border border-[#323232]"
                        />
                        <FontAwesomeIcon
                            icon={showRPassword ? faEye : faEyeSlash}
                            onClick={() => setShowRPassword(!showRPassword)}
                            className="absolute right-[1vw] top-1/2 transform -translate-y-1/2 cursor-pointer text-[#868686]"
                        />
                    </div>
                    <div className="relative w-full h-[12%]">
                        <input
                            onChange={e => setRPasswordC(e.target.value)}
                            placeholder="Parola"
                            type={showRCPassword ? "text" : "password"}
                            className="textSemiBold text-center outline-none placeholder-[#868686] text-[#868686] text-[1vw] w-full h-full bg-transparent rounded-[2vw] border border-[#323232]"
                        />
                        <FontAwesomeIcon
                            icon={showRCPassword ? faEye : faEyeSlash}
                            onClick={() => setShowRCPassword(!showRCPassword)}
                            className="absolute right-[1vw] top-1/2 transform -translate-y-1/2 cursor-pointer text-[#868686]"
                        />
                    </div>
                    <input
                        onChange={e => setRToken(e.target.value)}
                        placeholder="Token primit pe mail"
                        type="text"
                        className="textSemiBold text-center outline-none placeholder-[#868686] text-[#868686] text-[1vw] w-full h-[12%] bg-transparent rounded-[2vw] border border-[#323232]"
                    />
                    <div className="cursor-pointer mt-[5%] w-full h-[14%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
                        <span onClick={registerAccount} className="text-white textBold text-[1.5vw]">CREEAZĂ CONT</span>
                    </div>
                    <span
                        onClick={() => setIsLoginClicked(true)}
                        className="textMedium text-[1vw] text-[#00000060] cursor-pointer"
                    >
                        Ai deja un cont? <span className="textSemiBold gradient-text">Conecteaza-te</span>
                    </span>
                </div>

                <div className={`loginForm w-[62%] h-[55%] flex flex-col items-center justify-center pb-[6%] gap-[2%] mt-[5%] ${isLoginClicked ? 'flex' : 'hidden'}`}>
                    <input
                        onChange={e => setLEmail(e.target.value)}
                        placeholder="Email"
                        type="text"
                        className="textSemiBold text-center outline-none placeholder-[#868686] text-[#868686] text-[1vw] w-full h-[12%] bg-transparent rounded-[2vw] border border-[#323232]"
                    />
                    <div className="relative w-full h-[12%]">
                        <input
                            onChange={e => setLPassword(e.target.value)}
                            placeholder="Parola"
                            type={showLPassword ? "text" : "password"}
                            className="textSemiBold text-center outline-none placeholder-[#868686] text-[#868686] text-[1vw] w-full h-full bg-transparent rounded-[2vw] border border-[#323232]"
                        />
                        <FontAwesomeIcon
                            icon={showLPassword ? faEye : faEyeSlash}
                            onClick={() => setShowLPassword(!showLPassword)}
                            className="absolute right-[1vw] top-1/2 transform -translate-y-1/2 cursor-pointer text-[#868686]"
                        />
                    </div>
                    <div className="cursor-pointer mt-[5%] w-full h-[14%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
                        <span onClick={loginAccount} className="text-white textBold text-[1.5vw]">INTRĂ ÎN CONT</span>
                    </div>
                    <span
                        onClick={() => setIsLoginClicked(false)}
                        className="textMedium text-[1vw] text-[#00000060] cursor-pointer"
                    >
                        Nu ai un cont? <span className="textSemiBold gradient-text">Creeaza unul</span>
                    </span>
                </div>
                <img className="w-[15%] opacity-60" src={fplaytLogo} alt="Logo" />
                <span className="text-[#323232] textMedium text-[0.7vw]">Copyright 2025 - Bogdan & Tristan</span>
            </div>
            <Toaster
                position="top-right"
                reverseOrder={false}
            />
        </div>
    );
}

export default AuthPage;
